import Vue from 'vue';

Vue.component('ai-content-label', {
    name: 'AiContentLabel',

    props: {
        // { positionClass, iconUrl, alt, disclaimerText } or null
        label: {
            type: Object,
            default: null,
        },
    },

    template: `
    <div v-if="label" :class="'ai-content-label ai-content-label--' + label.positionClass">
      <img :src="label.iconUrl" :alt="label.alt" />
    </div>
    `,
});
